function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import * as React from 'react';
import { registerUser } from '../actions';
import { withRouter } from 'react-router-dom';
import { Grid, Container, Form, Input, Button, Message } from 'semantic-ui-react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import URLSearchParams from 'url-search-params';
import RegisterForm from '../components/RegisterForm';
import { getProductUrl } from '../helpers';

var Register = function (_React$Component) {
  _inherits(Register, _React$Component);

  function Register() {
    var _temp, _this, _ret;

    _classCallCheck(this, Register);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleSubmit = function (name, phoneNumber, password) {
      var location = _this.props.location;
      var searchParams = new URLSearchParams(location.search);
      var newToken = searchParams.get('token') || '';
      var productId = searchParams.get('productFamilyId') || '';
      var env = process.env.REACT_APP_RM_ENV ? process.env.REACT_APP_RM_ENV : process.env.REACT_APP_ENV;
      var redirectUrl = getProductUrl(productId, env);

      _this.props.registerUser(name, phoneNumber, password, newToken).then(function (success) {
        if (success === true) {
          if (redirectUrl === '/') {
            _this.props.history.push('/');
          } else {
            window.location.href = redirectUrl;
          }
        }
      }, function (failure) {});
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Register.prototype.render = function render() {
    var _props = this.props,
        location = _props.location,
        error = _props.error;
    return React.createElement('div', {
      className: 'page--multifaceted-bg-grey'
    }, React.createElement(Container, {
      className: 'page-container'
    }, React.createElement('div', {
      className: 'register-form'
    }, React.createElement(Grid, {
      stackable: true,
      centered: true
    }, React.createElement(Grid.Column, {
      width: 6
    }, React.createElement('div', {
      className: 'callout'
    }, React.createElement('h2', null, 'Register'), React.createElement(Grid, {
      stackable: true,
      centered: true
    }, React.createElement(Grid.Column, {
      width: 10
    }, error && React.createElement(Message, {
      warning: true,
      icon: false,
      content: error
    }), React.createElement(RegisterForm, {
      handleSubmit: this.handleSubmit
    })))))))));
  };

  return Register;
}(React.Component);

var mapStateToProps = function mapStateToProps(state) {
  return {
    isFetching: state.auth.user.isFetching,
    error: state.auth.user.error
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    registerUser: registerUser
  }, dispatch);
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Register));